var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.305 39.059"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.005 37.283a1.77 1.77 0 01.52-1.255l16.5-16.5-16.5-16.5a1.775 1.775 0 012.51-2.51l17.75 17.756a1.774 1.774 0 010 2.51L3.031 38.538a1.775 1.775 0 01-3.026-1.255z",
    fill: "#ccd6e0"
  })));
}
export default SvgArrowRightinline;